/**
 * Punto de entrada de la web: monta React con la caché de datos, los avisos y el enrutador.
 */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { ProveedorAvisos } from './componentes/Avisos';
import { ProveedorTema, aplicarTemaGuardado } from './features/tema/contexto';
import { ErrorDeApi } from './lib/api';
import './estilos/tokens.css';
import './estilos/base.css';

// `public/tema-inicial.js` ya aplicó el tema antes del primer pintado (sin parpadeo). Aquí se
// vuelve a aplicar desde las preferencias (fuente de verdad) y se refresca su caché.
aplicarTemaGuardado();

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      // Un error 4xx (sin permiso, no existe) no mejora reintentando; uno de red o 5xx, sí, un par de veces.
      retry: (intentos, error) =>
        !(error instanceof ErrorDeApi && error.estado >= 400 && error.estado < 500) && intentos < 2,
    },
  },
});

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('No se encontró el elemento #raiz en index.html.');

createRoot(raiz).render(
  <StrictMode>
    <ProveedorTema>
      <QueryClientProvider client={cliente}>
        <ProveedorAvisos>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ProveedorAvisos>
      </QueryClientProvider>
    </ProveedorTema>
  </StrictMode>,
);
